import axiosInstance from './axios.service';

const casillaService = {
  // Get all casillas for a board raffle
  getCasillasByRifa: async rifaId => {
    const { data } = await axiosInstance.get(`/api/casillas/rifa/${rifaId}`);
    return data;
  },

  // Get a single casilla
  swapCasillas: async (casillaIdA, casillaIdB) => {
    const { data } = await axiosInstance.put('/api/casillas/swap', {
      casillaIdA,
      casillaIdB,
    });
    return data;
  },
};

export default casillaService;
